// O PUT /tabelafrete/store valida ~40 campos e devolve o errors bag com o caminho
// cru do payload ("rota.0.itinerary_id"). O ReturnApi mostra só "Erro na validação
// dos dados.", então o operador — e quem for depurar — fica sem saber qual campo caiu.

const LEAF_LABELS = {
  cd: "Código",
  descr: "Descrição",
  obs: "Observação",
  tp_calc: "Tipo cálculo",
  tp_tabela: "Tabela",
  tp_receita_despesa: "Tipo",
  tp_composicao: "Composição",
  modal: "Modal",
  transportador: "Fornecedor",
  pessoa: "Cliente",
  municipio_origem: "Município origem",
  regiao_origem: "Região origem",
  municipio_destino: "Município destino",
  regiao_destino: "Região destino",
  itinerary_id: "Roteiro",
  tp_processo: "Processo",
  tp_operacao: "Operação",
  param_tipo_carga: "Carga",
  tp_carga: "Tipo carga",
  tp_rodado: "Veículo",
  transp: "Veículo",
  carroceria: "Carroceria",
  dt_vigencia_ini: "Início da vigência",
  dt_vigencia_fim: "Fim da vigência",
  vlr: "Valor frete",
  vlr_ini: "Faixa inicial",
  vlr_fim: "Faixa final",
  fixa: "Faixa fixa",
  excedente: "Excedente",
  vlr_exd: "Valor excedente",
  fator_conv: "Fator de conversão",
  tp_taxa_tda: "Tipo taxa TDA",
  tp_taxa_tde: "Tipo taxa TDE",
  taxa_tda: "Taxa TDA",
  taxa_tde: "Taxa TDE",
  vlr_fixo_tda: "Valor fixo TDA",
  vlr_fixo_tde: "Valor fixo TDE",
  tp_taxa_pedagio: "Tipo taxa pedágio",
  taxa_pedagio: "Pedágio por fração de",
  vlr_pedagio: "Valor pedágio",
  taxa_gris: "Taxa gris",
  vlr_minimo_gris: "Mínimo gris",
  ad_valorem: "Ad Valorem",
  vlr_minimo_advalorem: "Mínimo advalorem",
  vlr_min_nota_cte: "Valor mínimo nota/CTe",
  vlr_tas: "Valor TAS",
  vlr_sec_cat: "Valor SEC/CAT",
  vlr_despacho: "Valor despacho",
  vlr_agendamento: "Valor agendamento",
  vlr_outros: "Valor outros",
  taxa_devolucao: "Taxa devolução",
  taxa_reentrega: "Taxa reentrega",
  taxa_coleta: "Taxa de coleta",
  vlr_qtde_docs_fiscais: "Valor mínimo por rota",
  qtde_docs_fiscais: "Quantidade de notas",
  tp_trecho: "Tipo trecho",
  tp_trecho_custo: "Tipo trecho custo",
  custo: "Custo",
  vlr_taxa: "Taxa",
  taxa_comissao: "Taxa (%)",
  vlr_minimo: "Valor mínimo",
  rota_dup: "Rotas duplicadas",
  carga_dup: "Cargas duplicadas",
};

const GROUP_LABELS = {
  rota: "Rota",
  vigencia: "Vigência",
  calculo: "Faixa",
  carga: "Carga",
  transp: "Veículo",
  custo_extra: "Custo extra",
};

function twoDigits(index) {
  return String(Number(index) + 1).padStart(2, "0");
}

/** "rota.0.vigencia.1.dt_vigencia_ini" → "Rota 01 · Vigência 02 · Início da vigência" */
function describePath(path) {
  const parts = String(path).split(".");
  const trecho = [];

  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i];
    const next = parts[i + 1];

    if (GROUP_LABELS[part] && /^\d+$/.test(next || "")) {
      trecho.push(`${GROUP_LABELS[part]} ${twoDigits(next)}`);
      i += 1;
      continue;
    }
    if (/^\d+$/.test(part) || part === "value") continue;

    trecho.push(LEAF_LABELS[part] || part);
  }

  return trecho.join(" · ");
}

/**
 * Vira texto o errors bag de um 422. Devolve "" quando não há bag — nesse caso
 * o chamador deve seguir com o handleApiError normal.
 */
export function describeStoreValidationErrors(error) {
  const errors =
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors;

  if (!errors || typeof errors !== "object") return "";

  const linhas = Object.keys(errors)
    .map((path) => {
      const mensagens = errors[path];
      const mensagem = Array.isArray(mensagens) ? mensagens[0] : mensagens;
      if (!mensagem) return null;
      // Mensagem que já vem pronta do back (duplicidade de rota/carga) não ganha prefixo.
      if (path === "rota_dup" || path === "carga_dup") return String(mensagem);
      return `${describePath(path)}: ${mensagem}`;
    })
    .filter(Boolean);

  return linhas.join("\n");
}
